import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "carousel-content" }
const _hoisted_2 = { class: "upload" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "page" }

import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { Action } from '@/typeDefine/CommonTypes';
import { CarouselType } from '@/typeDefine/EntityType';
import { AdminGetCarouselByPageResponse, BaseResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { nextTick, onMounted, onUpdated, ref, Ref } from 'vue';
import Pagination from '../Pagination.vue';
import { ConstantField } from '@/constant/ConstantField';
import { ElLoading, ElMessage, ElMessageBox, LoadingOptions, UploadProps } from 'element-plus';
import { Loading } from '@/util/Loading';

//当前页

export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselManage',
  setup(__props) {

const currentPage: Ref<number> = ref(1)
//页大小
const pageSize: Ref<number> = ref(10)
//总页数
const totalPage: Ref<number> = ref(0)

//表格内容
const tableData: Ref<CarouselType[]> = ref([])

//上传轮播接口
const uploadApi: string = `${ConstantField.SERVER}/carousel/admin/add`

onMounted(() => nextTick(() => getCarousel(currentPage.value)))

//分页获取轮播图
const getCarousel: Action<[number, number?]> = async (currentPage: number, pageSize?: number) => {

    const response: AdminGetCarouselByPageResponse = await Api.instance.adminGetCarouselByPage({
        startPage: currentPage,
        pageSize,
    })

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        requestAnimationFrame(() => {
            tableData.value = response.data.carousel
            totalPage.value = response.data.totalPage

            let i: number = 0
            tableData.value = tableData.value.map(item => {
                const { path, ...rest } = item
                return {
                    ...rest,
                    order: ++i,
                    path: `${path}`,
                }
            })
        })
    }
}

//当前页改变
const pageChange: Action<[number]> = (value: number) => {
    getCarousel(value)
}

//删除轮播
const onDelete: Action<[CarouselType]> = async (row) => {
    ElMessageBox.confirm('将执行删除该轮播图操作,是否确定?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => onDeleteHandler(row.id)).catch(() => { })
}

const onDeleteHandler: Action<[number]> = async (id: number) => {

    const response: BaseResponse = await Api.instance.adminDeleteCarousel({
        id,
    })

    UtilMethods.showMessageToast(response)

    if (response.code === ResponseCode.OK) {
        refresh()
    }
}

//上传图片前校验
const beforeCarouselUpload: UploadProps['beforeUpload'] = (rawFile) => {
    if (!rawFile.type.startsWith('image')) {
        ElMessage.error('请上传图片类型文件')
        return false
    }

    Loading.instance.open('上传中...')
    return true
}

const handleCarouselSuccess: UploadProps['onSuccess'] = (response, uploadFile) => {

    Loading.instance.close()

    if (response === null) {
        return
    }

    UtilMethods.showMessageToast(response)

    if (response?.code === ResponseCode.OK) {
        refresh()
    }
}

//刷新表格
const refresh: Action = () => {
    currentPage.value = 1
    getCarousel(currentPage.value)
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_upload, {
        action: uploadApi,
        "show-file-list": false,
        "on-success": handleCarouselSuccess,
        "before-upload": beforeCarouselUpload,
        "on-error": _unref(Loading).instance.close,
        "with-credentials": ""
      }, {
        tip: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "el-upload__tip" }, " 请上传图片类型文件 ", -1)
        ])),
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("上传轮播图")
            ])),
            _: 1,
            __: [1]
          })
        ]),
        _: 1
      }, 8, ["on-error"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, " 轮播图管理 ", -1)),
      _createVNode(_component_el_table, {
        data: tableData.value,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "order",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "path",
            label: "图片"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_image, {
                style: {"width":"100px","height":"100px"},
                "preview-teleported": "",
                src: row.path,
                "min-scale": 0.2,
                fit: "cover",
                "preview-src-list": [row.path]
              }, null, 8, ["src", "preview-src-list"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间"
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                onClick: ($event: any) => (onDelete(row))
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" 删除 ")
                ])),
                _: 2,
                __: [3]
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Pagination, {
        "page-size": pageSize.value,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "total-page": totalPage.value,
        onCurrentPageChange: pageChange
      }, null, 8, ["page-size", "current-page", "total-page"])
    ])
  ]))
}
}

})